module.exports = __webpack_public_path__ + "static/artistAtWork-593c2f99b451bc9bf947dda0572e4729.png";